"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRemove = void 0;
var tslib_1 = require("tslib");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var index_1 = require("../../i18n/index");
var ACCOUNTS_REMOVE_SUCCESS = { key: index_1.T.ACCOUNTS_REMOVE_SUCCESS };
var AccountsConfirmRemove = /** @class */ (function (_super) {
    tslib_1.__extends(AccountsConfirmRemove, _super);
    function AccountsConfirmRemove(ctrl, user) {
        var _this = _super.call(this, {
            title: index_1.T.ACCOUNTS_REMOVE_TITLE,
            confirm: index_1.T.ACCOUNTS_REMOVE,
            success: ACCOUNTS_REMOVE_SUCCESS
        }) || this;
        _this.ctrl = ctrl;
        _this.user = user;
        return _this;
    }
    Object.defineProperty(AccountsConfirmRemove.prototype, "nodes", {
        get: function () {
            return (0, index_1.Translate)(index_1.T.ACCOUNTS_REMOVE_CONFIRM, this.user.username);
        },
        enumerable: false,
        configurable: true
    });
    AccountsConfirmRemove.prototype.submit = function () {
        return this.ctrl.removeUser(this.user);
    };
    AccountsConfirmRemove.prototype.failToChange = function () {
        this.ctrl.setLoading(this.user.objectId, false);
    };
    return AccountsConfirmRemove;
}(modal_form_component_1.ModalFormComponent));
exports.AccountsConfirmRemove = AccountsConfirmRemove;
//# sourceMappingURL=accounts.confirm.remove.js.map